import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { bootstrapApplication } from '@angular/platform-browser';
import { isBrowserOnlyPathname } from '@maximizer/oauth2/data-access';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { syncConfigurationAppConfig } from './app/sync-configuration-app.config';

registerLocaleData(localeFr, 'fr');

// Browser-only routes (e.g. `/sync-configuration` popup) skip `__officeReady` and use the no-Office config.
const isBrowserOnlyRoute = isBrowserOnlyPathname(globalThis.location.pathname);

if (isBrowserOnlyRoute) {
  bootstrapApplication(AppComponent, syncConfigurationAppConfig).catch(
    (error: unknown) => console.error('App error', error),
  );
} else {
  // `Office.onReady()` runs in index.html pre-zone.js to avoid zone-patched setTimeout racing Office.js readiness.
  (globalThis.__officeReady as Promise<unknown>)
    .then(() =>
      bootstrapApplication(AppComponent, appConfig).catch((error: unknown) =>
        console.error('App error', error),
      ),
    )
    .catch((officeError: unknown) => console.error('Office error', officeError));
}
